import constants from "@/config/constants";

let googleInstance
let loadingPromise

const createScript = () => {
    return new Promise((resolve) => {
        const el = document.getElementById('auth2_script_id')
        if (!el) {
            const gplatformScript = document.createElement('script')
            gplatformScript.setAttribute('src', 'https://accounts.google.com/gsi/client')
            gplatformScript.setAttribute('onload', 'onGapiLoad()');
            gplatformScript.setAttribute('async', true)
            gplatformScript.setAttribute('defer', true)
            gplatformScript.setAttribute('id', 'auth2_script_id')
            document.head.appendChild(gplatformScript)
        }
        resolve()
    })
}

const onGapiLoadPromise = () => {
    return new Promise((resolve, reject) => {
        window.onGapiLoad = () => {
            try {
                googleInstance = window.google
            } catch (err) {
                reject(Error('client_id missing or is incorrect'))
            }
            resolve(googleInstance)
        }
    })
}

const loadingAuth2 = () => {
    if (googleInstance) {
        return Promise.resolve(googleInstance)
    } else {
        if (!loadingPromise) loadingPromise = onGapiLoadPromise()
        return loadingPromise
    }
}

const load = () => {
    return Promise.all(
        [loadingAuth2(), createScript()])
        .then(results => {
            return results[0]
        })
}

const requestGoogleAuthCode = () => {
    return new Promise((resolve, reject) => {
        load()
            .then(() => {
                window.google.accounts.oauth2
                    .initCodeClient({
                        client_id: constants.GOOGLE_CLIENT_ID,
                        scope: 'email',
                        ux_mode: 'popup',
                        callback: (response) => {
                            if (response.code) {
                                resolve(response.code);
                            } else {
                                reject(response);
                            }
                        },
                    })
                    .requestCode();
            });
    });
}

export default {
    load,
    requestGoogleAuthCode
}
